import { AbsenceMotives } from 'src/types';

export const motiveOptions = [
  { value: AbsenceMotives.VACATIONS, label: 'Vacaciones' },
  { value: AbsenceMotives.LICENSE, label: 'Licencia' },
  { value: AbsenceMotives.STUDY, label: 'Estudio' },
];
